'use es6';

import { fromJS } from 'immutable';
import ActionTypes from '../constants/ActionTypes';
import RequestStatusTypes from '../constants/RequestStatusTypes';
var initialState = fromJS({
  goodId: null,
  parentId: null,
  goodName: '',
  open: false,
  submitReviewStatus: RequestStatusTypes.UNINITIALIZED,
  transactionId: null
});
export default function reviewInputInfoReducer() {
  var reviewInputInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.REVIEW_MODAL_OPENED:
      return reviewInputInfo.merge({
        open: true,
        goodId: action.payload.goodId,
        parentId: action.payload.parentId || '',
        goodName: action.payload.goodName,
        submitReviewStatus: RequestStatusTypes.UNINITIALIZED,
        transactionId: action.payload.transactionId
      });

    case ActionTypes.DISMISSED_REVIEW_MODAL:
      return initialState;

    case ActionTypes.REVIEW_SUBMITTED:
      if (action.error) {
        return reviewInputInfo.set('submitReviewStatus', RequestStatusTypes.FAILED);
      }

      return reviewInputInfo.set('submitReviewStatus', RequestStatusTypes.PENDING);

    case ActionTypes.REVIEW_SUBMITTED_FROM_DETAILS_SUCCESS:
    case ActionTypes.REVIEW_SUBMITTED_FROM_PURCHASES_SUCCESS:
      return reviewInputInfo.set('submitReviewStatus', RequestStatusTypes.SUCCEEDED);

    default:
      return reviewInputInfo;
  }
}